import _ from "lodash";
import React, { Component } from "react";
import {
  editBooth,
  showBoothEditor,
  updateBooth,
  addNewBooth,
} from "InteractiveMapAction";
import { connect } from "react-redux";
import { Rnd } from "react-rnd";

class RndBooth extends Component {
  constructor(props) {
    super(props);
    this.state = { dragging: false };
    this.onLocationClick.bind(this);
  }

  onLocationClick(e) {
    if (this.state.dragging) return;
    e.preventDefault();

    if (this.props.toAddNewBooth) {
      this.props.showBoothEditor(true);
    } else {
      this.props.editBooth(this.props.booth);
    }
  }

  onBoothDragStop(e) {
    var refThis = this;
    setTimeout(function () {
      refThis.setState({ dragging: false });
    }, 500);

    if (this.state.dragging) {
      var state = this.rnd.draggable.state;
      var updatedBooth = {
        ...this.props.booth,
        location_x: state.x,
        location_y: state.y,
      };
      this.updateBooth(updatedBooth);
    }
  }

  onBoothDrag(e) {
    this.setState({ dragging: true });
  }

  onBoothResizeStop(e) {
    var state = this.rnd.resizable.state;
    var updatedBooth = {
      ...this.props.booth,
      location_width: state.width,
      location_height: state.height,
    };
    this.updateBooth(updatedBooth);
  }

  updateBooth(booth) {
    //Check if booth created on server to update in server
    if (_.startsWith(booth.locationid, "booth")) {
      //Not stored in server, update locally
      this.props.addNewBooth(booth);
    } else {
      var boothToUpdate = { resource: [booth] };
      this.props.updateBooth(
        this.props.session,
        boothToUpdate,
        this.props.selectedMap.interactivemapid,
        () => {},
        () => {}
      );
    }
  }

  render() {
    var { booth, offset } = this.props;

    var x = booth.location_x; //-offset.x;
    var y = booth.location_y; //-offset.y;

    var cssstyle = {
      left: "0px",
      top: "0px",
      backgroundColor: booth.color,
    };

    var height = 50;
    var width = 50;
    if (booth.location_width !== 0) width = booth.location_width;

    if (booth.location_height !== 0) height = booth.location_height;

    return (
      <Rnd
        ref={(c) => {
          this.rnd = c;
        }}
        default={{
          x: x,
          y: y,
          width: width,
          height: height,
        }}
        minWidth={50}
        minHeight={50}
        bounds=".map-image"
        style={cssstyle}
        className="booth"
        z={99999}
        onDragStop={this.onBoothDragStop.bind(this)}
        onDrag={this.onBoothDrag.bind(this)}
        onResizeStop={this.onBoothResizeStop.bind(this)}
      >
        <div
          style={{ height: "100%" }}
          onClick={this.onLocationClick.bind(this)}
        >
          &nbsp;
        </div>
      </Rnd>
    );
  }
}
{
  /* <div style={cssstyle} className='booth' onClick={this.onLocationClick.bind(this)}>&nbsp;</div> */
}
function mapStateToProps(state) {
  return {
    session: state.session,
    toAddNewBooth: state.addEditBooth.toAddNewBooth,
    selectedMap: state.selectediMap,
  };
}

export default connect(mapStateToProps, {
  editBooth,
  showBoothEditor,
  updateBooth,
  addNewBooth,
})(RndBooth);
